import React from 'react';

type Props = {
  color: string;
  label?: string;
};

export default function Crayfish({ color, label }: Props) {
  return (
    <svg viewBox="0 0 96 34" role="img" aria-label={label || 'Kräfta'}>
      <g
        fill={color}
        stroke="#32170f"
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      >
        {/* Tail fan and long, visibly segmented abdomen. */}
        <path d="M10 12C6 7 2 7 1 10c3 2 5 4 6 6-4 0-6 2-6 5 3 2 7 1 10-1 1 4 4 6 7 5 1-3 0-6-2-9 2-2 2-5 0-8-3-1-6 2-6 6z" />
        <path d="M12 11c8-4 19-4 30-1v14c-11 3-22 3-30-1 3-4 3-8 0-12z" />
        <path
          d="M18 10c3 5 3 10 0 15M25 9c3 5 3 11 0 16M32 9c3 5 3 11 0 16M39 10c2 4 2 9 0 14"
          fill="none"
        />

        {/* Narrow carapace and head. */}
        <path d="M40 9C50 5 62 6 68 12l3 5-3 5c-6 6-18 7-28 3 3-5 3-11 0-16z" />

        {/* Two separate forward arms and pincers. */}
        <path d="M61 11c7-7 12-9 17-7l-2 5c-4 0-7 2-10 6z" />
        <path d="M76 4c5-4 11-4 14-1-4 1-6 3-7 6 4-2 8-1 10 2-5 5-12 4-17-2z" />
        <path d="M61 23c7 7 12 9 17 7l-2-5c-4 0-7-2-10-6z" />
        <path d="M76 30c5 4 11 4 14 1-4-1-6-3-7-6 4 2 8 1 10-2-5-5-12-4-17 2z" />

        {/* Walking legs stay compact enough to read at thirty-racer scale. */}
        <path
          d="M45 9l-6-7M51 8l-2-7M46 25l-6 7M53 26l-1 7M58 9l5-7M59 25l5 7"
          fill="none"
        />
      </g>

      <circle cx="66" cy="13" r="2" fill="#fff" stroke="#32170f" />
      <circle cx="66.5" cy="13" r="0.9" fill="#19120e" />
      <circle cx="66" cy="21" r="2" fill="#fff" stroke="#32170f" />
      <circle cx="66.5" cy="21" r="0.9" fill="#19120e" />

      {/* Long antennae remain legible in the small track rendering. */}
      <path
        d="M68 13C78 7 86 4 95 3M68 21c10 6 18 9 27 10"
        fill="none"
        stroke="#32170f"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
